module.exports = __webpack_public_path__ + "img/rss.14f34286.svg";